/* eslint-disable eqeqeq */
import { detect } from 'detect-browser';
import _ from 'underscore';
import Publisher from 'app/blocks/common/publisher';
import { supportCreditCardPayment } from 'app/blocks/common/utils';
import payment from 'app/pages/orders/orders.payment';
import validation from 'app/pages/orders/panel/payment/validation';

export default (p_, handler) => {
    const publisher = Publisher();
    const defaultState = {
        paymentDetails: {
            paymentMethod: p_.paymentMethods && p_.paymentMethods.length === 1 ? p_.paymentMethods[0] : null,
        },
    };
    const PaymentMethod = payment.method;

    const self = {
        publisher,

        payment,

        state: { ...defaultState },
        setState(patch) {
            self.state = { ...self.state, ...patch };
            publisher.notify(self.state);
        },
        validate() {
            return validation(self.state.paymentDetails);
        },
        isChanged() {
            return Object.keys(defaultState).some(
                key => self.state[key] && !_.isEqual(defaultState[key], self.state[key]),
            );
        },
        selectPayment(paymentDetails) {
            self.setState({ paymentDetails });
        },
        updatePayment(paymentDetails) {
            self.setState({ paymentDetails: { ...self.state.paymentDetails, ...paymentDetails } });
        },
        onPaymentMethodChange(paymentMethod) {
            self.updatePayment({ paymentMethod });
        },
        onPurchaseNumberChange(poNumber) {
            self.updatePayment({ poNumber });
        },
        onUpdateCardDetailsFlagChange() {
            self.updatePayment({ updateCardDetailsFlag: !self.state.updateCardDetailsFlag });
        },
        paymentMethodsAvailable: p_.paymentMethods || [],
        isPoNumberShouldBeDisabled() {
            const method = self.state.paymentDetails.paymentMethod;
            return method != PaymentMethod.PROFORMA && method != PaymentMethod.INVOICE;
        },
        isPaymentMethodEditable(method) {
            if (!p_.isOrderExisting) {
                return true;
            }
            const existingMethod = p_.initOrder.paymentDetails.paymentMethod;
            const availableMethods = p_.paymentMethodTransitions[existingMethod] || self.paymentMethodsAvailable;
            return availableMethods.indexOf(method) !== -1;
        },
        isPaymentMethodSupportedByBrowser() {
            return (
                self.state.paymentDetails.paymentMethod !== PaymentMethod.CREDIT_CARD.key ||
                supportCreditCardPayment(detect())
            );
        },
        isUpdateCardDetailsCheckboxShouldBeShown() {
            const isSupportedInCurrentRelease = false; // not supported in R1
            return (
                isSupportedInCurrentRelease &&
                p_.isOrderExisting &&
                p_.initOrder.paymentDetails.paymentMethod == PaymentMethod.CREDIT_CARD
            );
        },
    };

    publisher.subscribe(handler);
    setTimeout(() => publisher.notify(self.state), 0);

    return self;
};
